import { cn } from "@/lib/utils";
import type { ImageDetails } from "@/types";
import Image from "next/image";

const AnimatedLogoClouds = ({
	logos,
	className,
	logoClassname,
}: { logos: ImageDetails[]; className?: string; logoClassname?: string }) => {
	return (
		<div className={cn("flex animate-scroll gap-x-4 md:gap-x-16", className)}>
			{logos.map((logo, index) => (
				<div
					key={`${logo.alt}-${index}`}
					className="flex h-8 min-w-24 shrink-0 items-center justify-center md:h-10 md:min-w-40"
				>
					<Image
						className={cn(
							"max-h-8 w-auto object-contain md:max-h-10",
							logoClassname,
						)}
						src={logo.src}
						alt={logo.alt || ""}
						width={512}
						height={256}
						quality={100}
					/>
				</div>
			))}
		</div>
	);
};

export default AnimatedLogoClouds;
